import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { BrandedLoader } from '@orrekie/ui';
import { useHydrateUser } from '@orrekie/hooks/auth/useHydrateUser';
import { auth } from '../lib/firebase/config';

export const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const { user: hydratedUser, loading: hydrationLoading, error: hydrationError } = useHydrateUser();

  useEffect(() => {
    if (hydratedUser) {
      setCurrentUser(hydratedUser);
      setLoading(false);
      console.log('[AuthContext] Hydrated user from session cookie:', hydratedUser ? { email: hydratedUser.email, uid: hydratedUser.uid } : hydratedUser);
      return;
    }
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('[AuthContext] Fallback: Auth state changed:', user ? { email: user.email, uid: user.uid } : user);
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, [auth, hydratedUser]);

  const value = {
    currentUser,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {loading ? <BrandedLoader message="Loading authentication, please wait…" /> : children}
    </AuthContext.Provider>
  );
} 